import * as React from 'react';
import { useSelector } from 'react-redux';
import { orgUsageSelector } from '../../../redux/app/selectors/organization';
import { UsageTable } from './UsageTable';
import { UsageGraphSection } from './UsageGraphSection';

export const RegionUsageStats = () => {
  const usage = useSelector(orgUsageSelector);
  const regionRows = [];

  Object.keys(usage.region.stats).forEach((key) => {
    regionRows.push((
      <tr>
        <td>{usage.region.stats[key].country_name}</td>
        <td>
          $
          {usage.region.stats[key].avg_rate}
        </td>
        <td>{usage.region.stats[key].total_segments}</td>
        <td>
          $
          {usage.region.stats[key].total_balance}
        </td>
      </tr>
    ));
  });

  const pieTableRows = usage.region.regionPieData.map((row) => (
    <tr>
      <td>
        <span className="circle" style={{ background: row.color }} />
        &nbsp;&nbsp;
        <span className="fsz-11 bold-800" style={{ color: row.textColor }}>{row.name}</span>
      </td>
      <td>
        <span className="fsz-11 bold-800" style={{ color: row.textColor }}>{row.value}</span>
      </td>
    </tr>
  ));

  return (
    <>
      <UsageGraphSection datas={usage.region.regionPieData} rows={pieTableRows} />
      <UsageTable rows={regionRows} />
    </>
  );
};
